import {
  Directive,
  EventEmitter,
  HostListener,
  Output,
  Input,
} from '@angular/core';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { InvitationLinkComponent } from '../components/invitation-link/invitation-link.component';

@Directive({
  selector: '[appInvitationLinkModal]',
})
export class InvitationLinkModalDirective {
  @Input() disabled: boolean;
  @Output() requestInvitationLink = new EventEmitter();

  private modalRef: NgbModalRef;

  constructor(private readonly modalService: NgbModal) {}

  @HostListener('click') click() {
    if (this.disabled) {
      return;
    }
    this.requestInvitationLink.emit();
    this.modalRef = this.modalService.open(InvitationLinkComponent, {
      backdrop: 'static',
      keyboard: false,
    });
  }
}
